import styled from "styled-components";

export const PricingBreakdownContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
  width: 100%;
  margin-bottom: 2rem;
  padding: 0 1rem;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin-top: 1.5rem;
    padding: 0 2rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding: 0;
  }
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  width: 70%;
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  border-bottom: 2px solid #a9a9a9;
  height: auto;
  min-height: 5rem;
  padding-bottom: 0.5rem;

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    height: 6rem;
    min-height: auto;
  }
`;

export const SubTitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
  height: auto;
  min-height: 4rem;

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    height: 5rem;
    min-height: auto;
  }
`;

export const MonthlyPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 1rem;
  width: 100%;
`;

export const MonthlyAmountContainer = styled.div`
  text-align: right;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export const PricingBreakdownCard = styled.button`
  width: 100%;
  max-width: 320px;
  height: auto;
  min-height: 28rem;
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  text-align: left;
  border: none;
  background: #c1f7ce;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  padding: 0 1rem 0 1rem;
  margin-bottom: 0.75rem;
  /* Ensure minimum touch target */
  min-height: 44px;
  /* Improve touch interaction */
  -webkit-tap-highlight-color: rgba(59, 94, 171, 0.1);

  outline: ${(props) => (props.selected ? "2.8px solid #3B5EAB" : "none")};

  &:hover {
    cursor: pointer;
    outline: 2.8px solid ${(props) => (props.selected ? "#3B5EAB" : "#A9A9A9")};
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  }

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    width: calc(50% - 0.375rem);
    max-width: none;
    height: auto;
    min-height: auto;
    margin-bottom: 0.75rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    width: 21.5625rem;
    margin-bottom: 0;
  }
`;

export const PricingValueBubble = styled.div`
  background: ${(props) => (props.selected ? "#3B5EAB" : "#3B5EAB")};
  border-radius: 1.25rem;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  height: 2rem;
  width: calc(100% - 2rem);
  max-width: 260px;
  position: relative;
  top: -1rem;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.selected ? "#FFF" : "#FFF")};

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    width: 16rem;
    max-width: none;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    width: 18rem;
  }
`;

export const PricingValueBubbleText = styled.div`
  text-align: center;
  font-family: "DM Sans";
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1rem;
  }
`;

export const PricingBreakdownCardHeader = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.4rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    font-size: 1.6rem;
  }
`;

export const PricingBreakdownCardSubHeader = styled.div`
  color: #6a6a6a;
  font-family: "DM Sans";
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: left;
  padding-bottom: 0.5rem;
`;
// amount due today

export const MonthlyCost = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 1.275rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: inline-block;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.434rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    font-size: 1.594rem;
  }
`;

export const CurrencyType = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.2;
  padding-left: 0.25rem;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 0.8rem;
    padding-left: 0.5rem;
  }
`;

export const BillingPeriod = styled.div`
  color: #000;
  text-align: right;
  font-family: "DM Sans";
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.3;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1rem;
  }
`;

export const PricingLineItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const AdjustedLineItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-top: 1px solid #000;
  margin-bottom: 1rem;
  height: 1rem;
`;

export const PricingLineItem = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.4;
  padding-top: 0.5rem;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 0.8rem;
    padding-top: 0.75rem;
  }
`;

export const PackageDetailsContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid #000;
`;

export const PackageTotalsContainer = styled.div`
  width: 100%;
  height: auto;
  min-height: 5rem;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0.5rem;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0.5rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    height: 7.5rem;
    min-height: auto;
    padding-bottom: 0.5rem;
  }

  & > *:last-child {
    border-top: 1px solid #000;
    padding-top: 0.4rem;
    padding-bottom: 0;
  }
`;

export const PricingSubtotal = styled.div`
  color: #0050ff;
  font-family: "DM Sans";
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-top: 0.5rem;
  padding-bottom: 0.25rem;
`;

export const AnnualTotal = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-top: 0.5rem;
  padding-bottom: 0.215rem;
`;

export const PricingDiscount = styled.div`
  color: #0050ff;
  font-family: "DM Sans";
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-top: 0.5rem;
  padding-bottom: 0.25rem;
`;

export const PricingTotal = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-bottom: 0.25rem;
  margin-bottom: 0.5rem;
`;

export const PricingBreakdownCardFooter = styled.div`
  color: #000;
  text-align: left;
  font-family: "DM Sans";
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: 100%;
`;

export const PricingDueToday = styled.div`
  color: #000;
  text-align: right;
  font-family: "DM Sans";
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 1.5rem;
  }
`;
